import FileProviderViewState from '../store/schema/FileProviderViewState';
import getStore from '../store/store';
import { add, addToRemoving, load, remove, setLoadState } from '../actions/internalActions';
import { mutator } from 'satcheljs';

mutator(add, action => addProvider(action.providerViewState));
mutator(addToRemoving, action => {
    getStore().removalPending.set(action.providerType.toString(), '');
});
mutator(remove, action => {
    getStore().providers.delete(action.providerType.toString());
    getStore().removalPending.delete(action.providerType.toString());
});
mutator(load, action => action.providers.forEach(addProvider));
mutator(setLoadState, action => {
    getStore().loadState = action.loadState;
});

function addProvider(provider: FileProviderViewState) {
    getStore().providers.set(provider.viewType.toString(), provider);
}
